export const DASHBOARD_CONSTANTS = {
	enrollVesselCard: {
		imgURL: "../../images/boat.png",
		fillClr: "#002A4E",
		cardClr: "#DAE9FC",
		totalText: "Total",
		isEnrollActiveCard: true,
		totalEnrolledVesselsCount: 0,
		totalActiveVesselsCount: 0,
		cardHeader: "Enrolled Vessels",
		cardDescription:
			"The recording and certification of vessels used for coastal or inland navigation",
		cardType: "enroll_vessel",
		navigationURL: "/my-fleet",
	},
	portCodeCard: {
		imgURL: "../../images/vector.png",
		fillClr: "#002A4E",
		cardClr: "#E8E5FF",
		totalText: "Total",
		totalCount: 0,
		cardHeader: "Port Codes",
		cardDescription:
			"Locations for trade, like seaports and inland destinations, are assigned codes",
		cardType: "portcodes",
		navigationURL: "/port-codes",
	},
	reportCard: {
		imgURL: "../../images/file.png",
		fillClr: "#002A4E",
		cardClr: "#FFE2E7",
		borderClr: "#FFE2E7",
		totalText: "Total",
		totalCount: 0,
		cardHeader: "Reports",
		cardDescription:
			"The recording and certification of vessels used for coastal or inland navigation",
		cardType: "reports",
		navigationURL: "/reports",
	},
};

export const CHILD_REPORTS_CHART_DATA = {
	labels: ["DCS", "EU MRV", "UK MRV", "FEU", "UK ETS"],
	datasets: [
		{
			label: " Reports",
			data: [],
			backgroundColor: [
				"rgb(218, 31, 51)",
				"rgb(0, 42, 78)",
				"rgb(255 173 10)",
				"#16A085",
				"#8E44AD",
			],
			borderColor: [
				"rgb(218, 31, 51)",
				"rgb(0, 42, 78)",
				"rgb(255 173 10)",
				"#16A085",
				"#8E44AD",
			],
			borderColor: "white",
			borderWidth: 5,
		},
	],
};

export const regulationNames = ["DCS", "UKMRV", "EUMRV"];

export const notificationsData = [
	{ message: "Vessel has been modified - TEST, 9944860", isRead: true },
	{
		message:
			"Report has been rejected. Please review - A.H. FERBERT, 945612 for the upated status",
		isRead: true,
	},
	{
		message:
			"Report has been rejected. Please review - A.H. FERBERT, 945612 Please provide a proper data for the vessel detailsand Mention IMO Number.",
		isRead: true,
	},
	{
		message:
			"Report has been rejected. Please review - A.H. FERBERT, 945612 Please provide a proper data for the vessel details.",
		isRead: true,
	},
	{
		message:
			"Report has been rejected. Please review - A.H. FERBERT, 945612 Please provide a proper data for the vessel details.",
		isRead: false,
	},
	{
		message: "Report has been assigned - A.H. FERBERT, 945612",
		isRead: false,
	},
	{ message: "Vessel has been modified - TEST, 9944860", isRead: false },
	{
		message:
			"Report has been rejected. Please review - A.H. FERBERT, 945612",
		isRead: false,
	},
	{
		message:
			"Report has been rejected. Please review - A.H. FERBERT, 945612",
		isRead: false,
	},
];
